import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material"
import { useState } from "react"

export const WelcomeDialog = ({ show }) => {

    const [open, setOpen] = useState(show);

    const handleClose = () => {
        window.localStorage.setItem('welcome-dialog', 'true');
        setOpen(false);
    }

    return (
        <Dialog open={open}>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <Typography variant="h5">Welcome to nosi.io!</Typography>
                    <Typography>
                    Curious about what people are doing, reading, visiting, or thinking? nosi.io is your window into a world of shared experiences — books, places, people, and more — all tracked and curated by the community.
                    </Typography>
                    <Typography>
                    Don't see something you've done? Add it! Notice incorrect info? Help improve it! Everything here is shaped by users like you.
                    </Typography>
                    <Typography>
                    Explore trending spots, popular reads, and recent discoveries — and see what everyone's been nosi about lately.
                    </Typography>
                    <Typography>
                    You can browse freely, but to dive deeper, share your own experiences, and interact with the community, you'll need to sign up. Join now and start being nosi!
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}